import { Link, useLoaderData, useParams } from "react-router-dom";
import * as API from "../services/psicoterapia";

import { OpcionesEstadosTratamientos } from '../components/OpcionesEstadosTratamientos';

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getPsicoterapiaByID(params.psicoterapiaId);
}

export function PsicoterapiaItem(props) {
  const psicoterapia = useLoaderData();
  const errorMessage = psicoterapia?.message;

  const psicResp = psicoterapia.meta?.psicResp;
  const psicFecha = psicoterapia.meta?.metaFecha;
  const psicNumses = psicoterapia.meta?.psicNumses;
  const psicMedio = psicoterapia.meta?.psicMedio;
  const psicTipo = psicoterapia.meta?.psicTipo;
  const psicNeuronRad = psicoterapia.meta?.psicNeuronRad;
  const psicNeuronEsp = psicoterapia.meta?.psicNeuronEsp;
  const psicMedafRad = psicoterapia.meta?.psicMedafRad;
  const psicMedafEsp = psicoterapia.meta?.psicMedafEsp;
  const psicNaltRad = psicoterapia.meta?.psicNaltRad;
  const psicNaltEsp = psicoterapia.meta?.psicNaltEsp;
  const psicAntRad = psicoterapia.meta?.psicAntRad;
  const psicAntEsp = psicoterapia.meta?.psicAntEsp;
  const psicOtramedRad = psicoterapia.meta?.psicOtramedRad;
  const psicOtramedEsp = psicoterapia.meta?.psicOtramedEsp;
  const psicSueno = psicoterapia.meta?.psicSueno;
  const psicFrecuenciaSueno = psicoterapia.meta?.psicFrecuenciaSueno;
  const psicCalidadSueno = psicoterapia.meta?.psicCalidadSueno;
  const psicConsdrogprinc = psicoterapia.meta?.psicConsdrogprinc;
  const psicConsdrogotras = psicoterapia.meta?.psicConsdrogotras;
  const psicActivRad = psicoterapia.meta?.psicActivRad;
  const psicRelsocRad = psicoterapia.meta?.psicRelsocRad;
  const psicTestorinRad = psicoterapia.meta?.psicTestorinRad;
  const psicObs = psicoterapia.meta?.psicObs;
  const psicTipoDroga = psicoterapia.meta?.psicTipoDroga;
  const psicResult = psicoterapia.meta?.psicResult;
  const psicEstado = psicoterapia.meta?.psicEstado || 'seguimiento';

  const mindDate = new Date(psicoterapia.date);
  const diffDate = Math.abs(new Date() - mindDate) / 36e5;

  let { tratamientoId } = useParams();

  return (
    <>
      <div id='content'>
        {psicoterapia.length === 0 ? (
          <div>Cargando...</div>
        ) : errorMessage ? (
          <p>{errorMessage}</p>
        ) : (
          <form id='formUpdatelement'>
            <fieldset id='disabledContainer' disabled='disabled'>
              <div className='grid--2col'>
                <div className='field'>
                  <label htmlFor='psicResp'>Responsable</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='psicResp'
                      required
                      type='text'
                      readOnly
                      value={psicResp}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='psicFecha'>Fecha visita</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='psicFecha'
                      required
                      type='date'
                      readOnly
                      value={psicFecha}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='psicNumses'>Número de sesión</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='psicNumses'
                      required
                      disabled
                      type='number'
                      readOnly
                      value={psicNumses}
                    />
                  </div>
                </div>

                <div className='field'>
                <label htmlFor='psicMedio'>Asistencia / Medio</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='psicMedio'
                        required
                        name='psicMedio'
                        readOnly
                        value={psicMedio}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='presencial'>Presencial</option>
                        <option value='videoconferencia'>
                          Videoconferencia
                        </option>
                        <option value='no-asistencia'>No Asistencia</option>
                      </select>
                    </div>
                  </div>
                </div>

                {(props.userRole.includes('administrador')) && (
                <div className='field'>
                  <label htmlFor='psicEstado'>Estado de seguimiento</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='psicEstado'
                        readOnly
                        name='psicEstado'
                        value={psicEstado}
                      >
                        { OpcionesEstadosTratamientos.map((option) => (
                          <option
                            key={option.value}
                            value={option.value}
                            disabled={option.disabled}
                          >
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                )}

                {/* <div className='field'>
                  <label htmlFor='psicTipo'>Tipo</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='psicTipo'
                        required
                        name='psicTipo'
                        readOnly
                        value={psicTipo}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='Psicoterapia'>Psicoterapia</option>
                        <option value='Ypsilon'>Ypsilon</option>
                        <option value='Psiquiatria'>Psiquiatria</option>
                        <option value='Injustificada'>Injustificada</option>
                      </select>
                    </div>
                  </div>
                </div> */}
              </div>

              <div className='grid--2col'>
                <div className='field key' data-key={psicNeuronRad?.toString()}>
                  <div className='control'>
                    <label className='radio-title'>Neurontin</label>
                    <label className='radio' htmlFor='psicNeuronRadSi'>
                      <input
                        id='psicNeuronRadSi'
                        name='psicNeuronRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={psicNeuronRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='psicNeuronRadNo'>
                      <input
                        id='psicNeuronRadNo'
                        name='psicNeuronRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={psicNeuronRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>
                <div className='field lock'>
                  <label htmlFor='psicNeuronEsp'>
                    Neurontin-Especificar mg/día
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='psicNeuronEsp'
                      type='text'
                      readOnly
                      value={psicNeuronEsp}
                    />
                  </div>
                </div>
                <div className='field key' data-key={psicMedafRad?.toString()}>
                  <div className='control'>
                    <label className='radio-title'>Modafinilo</label>
                    <label className='radio' htmlFor='psicMedafRadSi'>
                      <input
                        id='psicMedafRadSi'
                        name='psicMedafRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={psicMedafRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='psicMedafRadNo'>
                      <input
                        id='psicMedafRadNo'
                        name='psicMedafRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={psicMedafRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>
                <div className='field lock'>
                  <label htmlFor='psicMedafEsp'>
                    Modafinilo-Especificar mg/día
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='psicMedafEsp'
                      type='text'
                      readOnly
                      value={psicMedafEsp}
                    />
                  </div>
                </div>
                <div className='field key' data-key={psicNaltRad?.toString()}>
                  <div className='control'>
                    <label className='radio-title'>Naltrexona</label>
                    <label className='radio' htmlFor='psicNaltRadSi'>
                      <input
                        id='psicNaltRadSi'
                        name='psicNaltRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={psicNaltRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='psicNaltRadNo'>
                      <input
                        id='psicNaltRadNo'
                        name='psicNaltRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={psicNaltRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>
                <div className='field lock'>
                  <label htmlFor='psicNaltEsp'>
                    Naltrexona-Especificar mg/día
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='psicNaltEsp'
                      type='text'
                      readOnly
                      value={psicNaltEsp}
                    />
                  </div>
                </div>

                <div className='field key' data-key={psicAntRad?.toString()}>
                  <div className='control'>
                    <label className='radio-title'>Antabus</label>
                    <label className='radio' htmlFor='psicAntRadSi'>
                      <input
                        id='psicAntRadSi'
                        name='psicAntRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={psicAntRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='psicAntRadNo'>
                      <input
                        id='psicAntRadNo'
                        name='psicAntRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={psicAntRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>
                <div className='field lock'>
                  <label htmlFor='psicAntEsp'>Antabus-Especificar mg/día</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='psicAntEsp'
                      type='text'
                      value={psicAntEsp}
                      readOnly
                    />
                  </div>
                </div>

                <div
                  className='field key'
                  data-key={psicOtramedRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>Otra medicación</label>
                    <label className='radio' htmlFor='psicOtramedRadSi'>
                      <input
                        id='psicOtramedRadSi'
                        name='psicOtramedRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={psicOtramedRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='psicOtramedRadNo'>
                      <input
                        id='psicOtramedRadNo'
                        name='psicOtramedRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={psicOtramedRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>
                <div className='field lock'>
                  <label htmlFor='psicOtramedEsp'>
                    Otra medicación - Especificar
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='psicOtramedEsp'
                      type='text'
                      readOnly
                      value={psicOtramedEsp}
                    />
                  </div>
                </div>
              </div>

            {psicSueno && (
              <div className='field key' data-key={psicSueno?.toString()}>
                <div className='control'>
                  <label className='radio-title'>Sueño</label>
                  <label className='radio' htmlFor='psicSueno01'>
                    <input
                      id='psicSueno01'
                      name='psicSueno'
                      type='radio'
                      value='Bueno'
                      readOnly
                      checked={psicSueno === "Bueno"}
                    />
                    Bueno
                  </label>
                  <label className='radio' htmlFor='psicSueno02'>
                    <input
                      id='psicSueno02'
                      name='psicSueno'
                      type='radio'
                      value='Regular'
                      readOnly
                      checked={psicSueno === "Regular"}
                    />
                    Regular
                  </label>
                  <label className='radio' htmlFor='psicSueno03'>
                    <input
                      id='psicSueno03'
                      name='psicSueno'
                      type='radio'
                      value='Malo'
                      readOnly
                      checked={psicSueno === "Malo"}
                    />
                    Malo
                  </label>
                </div>
              </div>
            )}

            <div className='grid--2col'>
              <div className='field'>
                <label htmlFor='psicFrecuenciaSueno'>
                  Frecuencia de dificultades para conciliar o mantener el sueño
                </label>
                <div className='control'>
                  <div className='select'>
                    <select
                      className='select'
                      id='psicFrecuenciaSueno'
                      name='psicFrecuenciaSueno'
                      required
                      value={psicFrecuenciaSueno}

                    >
                      <option disabled value=''>
                        -- Selecciona una opción --
                      </option>
                      <option value='casi-nunca'>
                        Casi nunca (menos de 1 noche por semana)
                      </option>
                      <option value='algunas-veces'>
                        Algunas veces (1-2 noches por semana)
                      </option>
                      <option value='a-menudo'>
                        A menudo (3-4 noches por semana)
                      </option>
                      <option value='casi-siempre'>
                        Casi siempre (5-7 noches por semana)
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div className='field'>
                <label htmlFor='psicCalidadSueno'>
                  Calidad general del sueño
                </label>
                <div className='control'>
                  <div className='select'>
                    <select
                      className='select'
                      id='psicCalidadSueno'
                      name='psicCalidadSueno'
                      readOnly
                      value={psicCalidadSueno}
                    >
                      <option disabled value=''>
                        -- Selecciona una opción --
                      </option>
                      <option value='muy-buena'>
                        Muy buena (se siente descansado y con energía al despertar)
                      </option>
                      <option value='buena'>
                        Buena (generalmente se siente descansado)
                      </option>
                      <option value='regular'>
                        Regular (a veces se siente cansado durante el día)
                      </option>
                      <option value='mala'>
                        Mala (raramente se siente descansado)
                      </option>
                      <option value='muy-mala'>
                        Muy mala (se siente constantemente cansado y con falta de energía)
                      </option>
                    </select>
                  </div>
                </div>
              </div>

          </div>


              

              <div
                className='field key'
                data-key={psicConsdrogprinc?.toString()}
              >
                <div className='control'>
                  <label className='radio-title'>Consumo droga principal</label>
                  <label className='radio' htmlFor='psicConsdrogprinc01'>
                    <input
                      id='psicConsdrogprinc01'
                      name='psicConsdrogprinc'
                      type='radio'
                      value='No ha consumido'
                      readOnly
                      checked={psicConsdrogprinc === "No ha consumido"}
                    />
                    No ha consumido
                  </label>
                  <label className='radio' htmlFor='psicConsdrogprinc02'>
                    <input
                      id='psicConsdrogprinc02'
                      name='psicConsdrogprinc'
                      type='radio'
                      value='Se sospecha consumo'
                      readOnly
                      checked={psicConsdrogprinc === "Se sospecha consumo"}
                    />
                    Se sospecha consumo
                  </label>
                  <label className='radio' htmlFor='psicConsdrogprinc03'>
                    <input
                      id='psicConsdrogprinc03'
                      name='psicConsdrogprinc'
                      type='radio'
                      value='Si ha consumido'
                      readOnly
                      checked={psicConsdrogprinc === "Si ha consumido"}
                    />
                    Sí ha consumido
                  </label>
                </div>
              </div>

              <div
                className='field key'
                data-key={psicConsdrogotras?.toString()}
              >
                <div className='control'>
                  <label className='radio-title'>Consumo otras drogas</label>
                  <label className='radio' htmlFor='psicConsdrogotras01'>
                    <input
                      id='psicConsdrogotras01'
                      name='psicConsdrogotras'
                      type='radio'
                      value='No ha consumido'
                      readOnly
                      checked={psicConsdrogotras === "No ha consumido"}
                    />
                    No ha consumido
                  </label>
                  <label className='radio' htmlFor='psicConsdrogotras02'>
                    <input
                      id='psicConsdrogotras02'
                      name='psicConsdrogotras'
                      type='radio'
                      value='Se sospecha consumo'
                      readOnly
                      checked={psicConsdrogotras === "Se sospecha consumo"}
                    />
                    Se sospecha consumo
                  </label>
                  <label className='radio' htmlFor='psicConsdrogotras03'>
                    <input
                      id='psicConsdrogotras03'
                      name='psicConsdrogotras'
                      type='radio'
                      value='Si ha consumido'
                      readOnly
                      checked={psicConsdrogotras === "Si ha consumido"}
                    />
                    Sí ha consumido
                  </label>
                </div>
              </div>

              <div className='grid--2col'>
                <div className='field key' data-key={psicActivRad?.toString()}>
                  <div className='control'>
                    <label className='radio-title'>Actividades</label>
                    <label className='radio' htmlFor='psicActivRadSi'>
                      <input
                        id='psicActivRadSi'
                        name='psicActivRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={psicActivRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='psicActivRadNo'>
                      <input
                        id='psicActivRadNo'
                        name='psicActivRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={psicActivRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>
                <div className='field key' data-key={psicRelsocRad?.toString()}>
                  <div className='control'>
                    <label className='radio-title'>Relaciones sociales</label>
                    <label className='radio' htmlFor='psicRelsocRadSi'>
                      <input
                        id='psicRelsocRadSi'
                        name='psicRelsocRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={psicRelsocRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='psicRelsocRadNo'>
                      <input
                        id='psicRelsocRadNo'
                        name='psicRelsocRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={psicRelsocRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>
                {/* <div
                  className='field key'
                  data-key={psicTestorinRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>Test de orina</label>
                    <label className='radio' htmlFor='psicTestorinRadSi'>
                      <input
                        id='psicTestorinRadSi'
                        name='psicTestorinRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={psicTestorinRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='psicTestorinRadNo'>
                      <input
                        id='psicTestorinRadNo'
                        name='psicTestorinRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={psicTestorinRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div> */}
                {/* <div className='lock'>
                  <div className='field'>
                    <label htmlFor='psicTipoDroga'>Tipo de droga</label>
                    <div className='control'>
                      <div className='select'>
                        <select
                          className='select'
                          id='psicTipoDroga'
                          name='psicTipoDroga'
                          readOnly
                          value={psicTipoDroga}
                        >
                          <option disabled value=''>
                            -- Selecciona una opción --
                          </option>
                          <option value='cocai'>Cocaína</option>
                          <option value='alcoh'>Alcohol</option>
                          <option value='hach'>Hachís</option>
                          <option value='benzo'>Benzodiacepinas</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className='field'>
                    <label htmlFor='psicResult'>Resultado</label>
                    <div className='control'>
                      <div className='select'>
                        <select
                          className='select'
                          id='psicResult'
                          name='psicResult'
                          readOnly
                          value={psicResult}
                        >
                          <option disabled value=''>
                            -- Selecciona una opción --
                          </option>
                          <option value='posit'>Positivo</option>
                          <option value='negat'>Negativo</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>

              <div className='field'>
                <label className='' htmlFor='psicObs'>
                  Observaciones
                </label>
                <div className='control'>
                  <textarea
                    className='textarea'
                    name='psicObs'
                    id='psicObs'
                    readOnly
                    value={psicObs}
                  ></textarea>
                </div>
              </div>
            </fieldset>
          </form>
        )}
      </div>
      {!errorMessage && (
        <div id='actions'>
          {((diffDate <= 72 && props.userRole.includes('psicologia')) || props.userRole.includes('administrador')) && (
            <Link className='button is-link' to={`edit`}>
              Editar
            </Link>
          )}
          {(props.userRole.includes('administrador') || props.userRole.includes('psicologia')) && (
            <Link
              className='button is-link'
              to={`../${tratamientoId}/seguimiento/psicoterapia/new`}
            >
              Nuevo
            </Link>
          )}
        </div>
      )}
    </>
  );
}
